module.exports = __webpack_public_path__ + "fca1820304350c913342d813e6097461.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Regular.ttf
// module id = 364
// module chunks = 0